/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — part of the Solvetia
 * white-label additions to Chatwoot Community Edition (MIT). Not derived from
 * the commercial code under enterprise/.
 */
import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/account-roles'),
      component: SettingsWrapper,
      meta: {
        permissions: ['administrator'],
      },
      children: [
        {
          path: '',
          name: 'account_roles_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
